module.exports = __webpack_public_path__ + "static/media/city_icon.3cb1b574.svg";